import React, { useEffect, useState } from "react";
import "./App.css";
import mainBg from "./assets/images/invest-bg.png";
import Footer from "./components/Rasoda/footer";
import Index from "./components/Ui-Elements/mobileInput";
import Navbar from "./components/Navbar/navbar";
import PageTop from "./components/Ui-Elements/pageTopArrow";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const BecomeAnInvestor = (props) => {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [answer, setAnswer] = useState("");
  const [userAnswer, setUserAnswer] = useState("");
  const [verificationMessage, setVerificationMessage] = useState("");
  const [verificationSuccess, setVerificationSuccess] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [loading, setLoading] = useState(false);

  const form = useForm();

  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitSuccessful },
  } = form;

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const newNum1 = Math.floor(Math.random() * 10);
    const newNum2 = Math.floor(Math.random() * 10);
    const newAnswer = newNum1 + newNum2;

    setNum1(newNum1);
    setNum2(newNum2);
    setAnswer(newAnswer);
    setUserAnswer("");
  };
  const handleInputChange = (e) => {
    setUserAnswer(e.target.value);
  };

  const onSubmit = async (data) => {
    if (parseInt(userAnswer, 10) === answer) {
      setVerificationMessage("Captcha Verification successful.");
      setVerificationSuccess(true);
      setLoading(true);

      const formData = {
        ...data,
        mobile: phoneNumber,
        countryCode: countryCode,
      };
      try {
        const response = await axios.post(
          "https://prod-api.rasoda.org/chef/v1/investors/register",
          formData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        toast.success(response.data.message);
        reset();
        setPhoneNumber("");
        setCountryCode("");
      } catch (error) {
        toast.error(error.response.data.message);
      } finally {
        setLoading(false);
      }
    } else {
      setVerificationMessage("Captcha Verification failed.");
      setVerificationSuccess(false);
    }
  };

  return (
    <>
      <Navbar />
      <section className="shadow-3xl p-[20px] rounded-[40px] mb-10 custom-container mt-10">
        <section className="main-invest">
          <div className="flex gap-10 flex-wrap justify-around">
            <div>
              <div className="text-5xl font-bold text-[#004372] p-10 mt-10">
                <h1>Next Level</h1>
                <h1>Partnerships</h1>
              </div>
              <img src={mainBg} alt="image not found" className="" />
            </div>
            <div className="mt-10">
              <div className="container1">
                <div className="heading">Become an Investor</div>
                <form className="form" onSubmit={handleSubmit(onSubmit)}>
                  <input
                    required
                    className="input"
                    type="text"
                    name="name"
                    id="firstName"
                    placeholder="Full Name"
                    {...register("name", { required: true })}
                  />
                  <input
                    required
                    className="input"
                    type="email"
                    name="emailId"
                    id="email"
                    placeholder="E-mail"
                    {...register("emailId", { required: true })}
                  />
                  <div className="mt-2">
                    <Index
                      setPhoneNumber={setPhoneNumber}
                      setCountryCode={setCountryCode}
                    />
                  </div>

                  <div>
                    <div className="flex gap-4 mt-4 ml-4 flex-wrap">
                      <lable className="mt-1 text-gray-500">
                        Verify Captcha :{" "}
                      </lable>
                      <p className="mt-1">
                        {num1} + {num2} =
                      </p>
                      <input
                        type="text"
                        value={userAnswer}
                        onChange={handleInputChange}
                        className="w-10 h-8 captchain rounded text-center"
                      />
                    </div>
                    <p
                      className={
                        verificationSuccess ? "text-green-500" : "text-red-500"
                      }
                    >
                      {verificationMessage}
                    </p>
                  </div>
                  <div>
                    <button
                      className="bg-red-600 login-button"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? (
                        <div class="flex items-center justify-center">
                          <svg
                            aria-hidden="true"
                            className="w-[102px] h-6 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            />
                          </svg>
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Send Enquiry"
                      )}
                    </button>
                  </div>
                </form>
                <span className="agreement">
                  <Link
                    to="/news"
                    className="border-b-2 border-[#0099ff] text-2xl"
                  >
                    Investor Login
                  </Link>
                </span>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </section>
      <PageTop />
    </>
  );
};

export default BecomeAnInvestor;
